import React from "react";
import moment from "moment";

const PremiumModernTemplate = ({ packageData, user }) => {
  if (!packageData?.package) return <div>Loading package data...</div>;
  const { package: pkg } = packageData;

  return (
    <div
      className="premium-modern-template"
      style={{ fontFamily: "'Inter', sans-serif", color: "#2D3748" ,  padding: "30px"}}
    >
      <div
        style={{
          background: "linear-gradient(135deg, #BE7FD4 0%, #BE7FD4 100%)",
          color: "white",
          padding: "30px",
          borderRadius: "12px",
          marginBottom: "30px",
        }}
      >
        <div className="d-flex justify-content-between align-items-start">
          {user?.logo && (
            <img
              src={user.logo}
              alt="Company Logo"
              style={{
                height: "60px",
                background: "white",
                padding: "8px",
                borderRadius: "8px",
              }}
            />
          )}
          <div style={{ textAlign: "right" }}>
            <p className="mb-1">{pkg.contactName}</p>
            <p className="mb-1">{pkg.contactEmail}</p>
            <p className="mb-0">{pkg.contactPhoneNumber}</p>
          </div>
        </div>

        <div className="text-center mt-4">
          <h1
            style={{
              fontSize: "2.5rem",
              fontWeight: "700",
              marginBottom: "10px",
            }}
          >
            {pkg.packageName}
          </h1>
          <p style={{ fontSize: "1.2rem", opacity: "0.9" }}>
            {pkg.destinationsCover}
          </p>
        </div>
      </div>

      <div className="row mb-4">
        <div className="col-md-8">
          <img
            src={pkg.imageSrc}
            alt={pkg.packageName}
            style={{
              width: "100%",
              height: "350px",
              objectFit: "cover",
              borderRadius: "12px",
            }}
            onError={(e) => (e.target.style.display = "none")}
          />
        </div>
        <div className="col-md-4">
          <div
            style={{
              background: "#F7FAFC",
              padding: "20px",
              borderRadius: "12px",
              height: "100%",
            }}
          >
            <h3
              style={{
                color: "#4A5568",
                borderBottom: "2px solid #667eea",
                paddingBottom: "10px",
                marginBottom: "20px",
              }}
            >
              Package Summary
            </h3>
            <div className="mb-3">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "12px",
                }}
              >
                <span
                  style={{
                    background: "#667eea",
                    width: "24px",
                    height: "24px",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginRight: "12px",
                    color: "white",
                  }}
                >
                  ⏱
                </span>
                <div>
                  <strong>Duration:</strong> {pkg.duration}
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "12px",
                }}
              >
                <span
                  style={{
                    background: "#667eea",
                    width: "24px",
                    height: "24px",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginRight: "12px",
                    color: "white",
                  }}
                >
                  📅
                </span>
                <div>
                  <strong>Start Date:</strong>{" "}
                  {moment(pkg.startedDate).format("MMMM Do, YYYY")}
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "12px",
                }}
              >
                <span
                  style={{
                    background: "#667eea",
                    width: "24px",
                    height: "24px",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginRight: "12px",
                    color: "white",
                  }}
                >
                  📍
                </span>
                <div>
                  <strong>Destinations:</strong> {pkg.destinationsCover}
                </div>
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <span
                  style={{
                    background: "#667eea",
                    width: "24px",
                    height: "24px",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginRight: "12px",
                    color: "white",
                  }}
                >
                  💰
                </span>
                <div>
                  <strong>Price:</strong> {pkg.price} {pkg.currency}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="mb-4">
        <h3
          style={{
            color: "#4A5568",
            borderLeft: "4px solid #667eea",
            paddingLeft: "12px",
            marginBottom: "20px",
          }}
        >
          Overview
        </h3>
        <p style={{ lineHeight: "1.6", fontSize: "1.1rem" }}>
          {pkg.description}
        </p>
      </div>

      {packageData.itineraries?.length > 0 && (
        <div className="mb-4">
          <h3
            style={{
              color: "#4A5568",
              borderLeft: "4px solid #667eea",
              paddingLeft: "12px",
              marginBottom: "20px",
            }}
          >
            Itinerary
          </h3>
          <div className="mb-3 p-3">
            {packageData.itineraries
              .slice()
              .sort((a, b) => new Date(a.date) - new Date(b.date))
              .map((item, index) => (
                <div key={index} className="mb-3 p-3">
                  <div className="timeline-content">
                    <h5>
                      {moment(item.date).format("MMMM Do, YYYY")} - {item.title}
                    </h5>
                    <p>
                      <strong>Location:</strong> {item.location}
                    </p>
                    <p>{item.description}</p>
                    {item.meals && (
                      <p>
                        <strong>Meals:</strong> {item.meals}
                      </p>
                    )}
                    {item.note && (
                      <p>
                        <strong>Note:</strong> {item.note}
                      </p>
                    )}
                  </div>
                </div>
              ))}
          </div>
        </div>
      )}
      {packageData.flightBookings?.length > 0 && (
        <div className="mb-4">
          <h3
            style={{
              color: "#4A5568",
              borderLeft: "4px solid #667eea",
              paddingLeft: "12px",
              marginBottom: "20px",
            }}
          >
            Flight Details
          </h3>
          {packageData.flightBookings.map((flight, index) => (
            <div
              key={index}
              className="mb-3 p-3"
              style={{ backgroundColor: "#f8f9fa", borderRadius: "5px" }}
            >
              <h5>
                {flight.airline} - Flight {flight.flightNumber}
              </h5>
              <p>
                <strong>Departure:</strong> {flight.departureCity} at{" "}
                {moment(flight.departureDateTime).format("MMM Do, YYYY h:mm a")}
              </p>
              <p>
                <strong>Arrival:</strong> {flight.arrivalCity} at{" "}
                {moment(flight.arrivalDateTime).format("MMM Do, YYYY h:mm a")}
              </p>
              <p>
                <strong>Class:</strong> {flight.cabinClass}
              </p>
            </div>
          ))}
        </div>
      )}
      {packageData.hotelBookings?.length > 0 && (
        <div className="mb-4">
          <h3
            style={{
              color: "#4A5568",
              borderLeft: "4px solid #667eea",
              paddingLeft: "12px",
              marginBottom: "20px",
            }}
          >
            Hotel Bookings
          </h3>
          <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Hotel</th>
                  <th>City</th>
                  <th>Check-In</th>
                  <th>Check-Out</th>
                  <th>Room Type</th>
                </tr>
              </thead>
              <tbody>
                {packageData.hotelBookings.map((hotel, index) => (
                  <tr key={index}>
                    <td>{hotel.hotelName}</td>
                    <td>{hotel.city}</td>
                    <td>{moment(hotel.checkInDate).format("MMM Do, YYYY")}</td>
                    <td>{moment(hotel.checkOutDate).format("MMM Do, YYYY")}</td>
                    <td>{hotel.roomType}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
      {packageData.sightSeeings?.length > 0 && (
        <div className="mb-4">
          <h3
            style={{
              color: "#4A5568",
              borderLeft: "4px solid #667eea",
              paddingLeft: "12px",
              marginBottom: "20px",
            }}
          >
            Sightseeing
          </h3>
          <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Destination</th>
                  <th>Attraction</th>
                  <th>Description</th>
                </tr>
              </thead>
              <tbody>
                {packageData.sightSeeings.map((sight, index) => (
                  <tr key={index}>
                    <td>{moment(sight.date).format("MMM Do, YYYY")}</td>
                    <td>{sight.destination}</td>
                    <td>{sight.sightseeingName}</td>
                    <td>{sight.description}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
       {packageData.transfers?.length > 0 && (
        <div className="mb-4">
          <h3
            style={{
              color: "#4A5568",
              borderLeft: "4px solid #667eea",
              paddingLeft: "12px",
              marginBottom: "20px",
            }}
          >
            Transfers
          </h3>
          <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Pickup Time</th>
                  <th>From</th>
                  <th>To</th>
                  <th>Vehicle</th>
                </tr>
              </thead>
              <tbody>
                {packageData.transfers.map((transfer, index) => (
                  <tr key={index}>
                    <td>{moment(transfer.date).format("MMM Do, YYYY")}</td>
                    <td>{transfer.pickupTime}</td>
                    <td>{transfer.fromLocation}</td>
                    <td>{transfer.toLocation}</td>
                    <td>{transfer.vehicleDetails}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {(packageData.includes?.length > 0 ||
        packageData.excludes?.length > 0) && (
        <div className="row mb-4">
          {packageData.includes?.length > 0 && (
            <div className="col-md-6">
              <h3
                style={{
                  color: "#4A5568",
                  borderLeft: "4px solid #667eea",
                  paddingLeft: "12px",
                  marginBottom: "20px",
                }}
              >
                Includes
              </h3>
              <ul>
                {packageData.includes.map((item, index) => (
                  <li key={index}>{item.description}</li>
                ))}
              </ul>
            </div>
          )}
          {packageData.excludes?.length > 0 && (
            <div className="col-md-6">
              <h3
                style={{
                  color: "#4A5568",
                  borderLeft: "4px solid #667eea",
                  paddingLeft: "12px",
                  marginBottom: "20px",
                }}
              >
                Excludes
              </h3>
              <ul>
                {packageData.excludes.map((item, index) => (
                  <li key={index}>{item.description}</li>
                ))}
              </ul>
            </div>
          )}
        </div>
      )}
      {packageData.termsandConditions?.length > 0 && (
        <div className="mb-4">
          <h3
            style={{
              color: "#4A5568",
              borderLeft: "4px solid #667eea",
              paddingLeft: "12px",
              marginBottom: "20px",
            }}
          >
            Terms & Conditions
          </h3>
          {packageData.termsandConditions.map((term, index) => (
            <div key={index} className="mb-2">
              <h5>{term.title}</h5>
              <p>{term.description}</p>
            </div>
          ))}
        </div>
      )}

      <style>
        {`
          .timeline {
            position: relative;
            padding-left: 30px;
          }
          
          .timeline-item {
            position: relative;
            margin-bottom: 30px;
          }
          
          .timeline-marker {
            position: absolute;
            left: -30px;
            top: 8px;
            width: 16px;
            height: 16px;
            borderRadius: 50%;
            background: #667eea;
            border: 3px solid white;
            box-shadow: 0 0 0 3px #667eea;
          }
          
          .timeline-content {
            background: #F7FAFC;
            padding: 20px;
            borderRadius: 8px;
            borderLeft: 3px solid #667eea;
          }
        `}
      </style>
    </div>
  );
};

export default PremiumModernTemplate;
